import base from './configService'

const tipoIncidenciaServices = {}

tipoIncidenciaServices.getTipos = function () {
    return base.get('/IncidenceType')
      .then(res => {
        return res.data;
      })
      .catch(e => {
        return Promise.reject(e);
      })
}

export default tipoIncidenciaServices